import * as React from 'react';
import { BroadcomLogo } from './BroadcomLogo';
import { Box, Link, Theme, Typography } from '@mineral/core';
import { Icon403 } from 'Utils/Icons/Icon403';
import { UnauthorizedEnums } from './Enums';

export const Unauthorized: React.FC = () => {
  const env = process.env.REACT_APP_ENVIRONMENT;
  const requestSubject = UnauthorizedEnums.requestAccessMailSubject.replace(
    '$env$',
    env as string
  );
  const requestBody = `${
    UnauthorizedEnums.requestAccessMailBodyLine1
  }%0D%0A%0D%0A${UnauthorizedEnums.requestAccessMailBodyLine2.replace(
    '$env$',
    env as string
  )}%0D%0A%0D%0A${UnauthorizedEnums.requestAccessMailBodyLine3}`;

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        minHeight: (theme: Theme) => `calc(100vh - ${theme.spacing(6)})`,
        padding: 2,
        textAlign: 'center',
      }}>
      <BroadcomLogo sx={{ height: 24, width: 175 }} />
      <Typography
        variant="h2"
        className="title"
        sx={(theme: Theme) => {
          return { margin: `${theme.spacing(4)} 0` };
        }}>
        {UnauthorizedEnums.title}
      </Typography>
      <Icon403 sx={{ maxWidth: '70vw', width: 'unset', height: 'unset' }} />
      <Typography
        variant="h2"
        className="title"
        sx={(theme: Theme) => {
          return { margin: `${theme.spacing(4)} 0` };
        }}>
        {UnauthorizedEnums.accessForbidden}
      </Typography>
      <Typography variant="h3" sx={{ fontWeight: 400 }}>
        {UnauthorizedEnums.accessForbiddenStatement}
      </Typography>
      <Typography variant="h3" sx={{ fontWeight: 400 }}>
        {UnauthorizedEnums.requestAccess}{' '}
        <Link
          sx={{ cursor: 'pointer' }}
          href={`mailto:iceadminhelp.pdl@broadcom.com?subject=${requestSubject}&body=${requestBody}`}>
          Support Team
        </Link>
      </Typography>
    </Box>
  );
};
